var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_228_1495)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_228_1495)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_1495)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_228_1495",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8H8V32H32V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_228_1495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16C28.8807 16 30 14.8807 30 13.5C30 12.1193 28.8807 11 27.5 11C26.1193 11 25 12.1193 25 13.5C25 14.8807 26.1193 16 27.5 16Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16C28.8807 16 30 14.8807 30 13.5C30 12.1193 28.8807 11 27.5 11C26.1193 11 25 12.1193 25 13.5C25 14.8807 26.1193 16 27.5 16Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.72 17.31C28.02 17.53 27.25 17.57 26.45 17.37C25.11 17.02 24.02 15.95 23.65 14.61C23.47 13.96 23.46 13.32 23.57 12.74C23.7 12.1 23.25 11.5 22.61 11.5H15C12 11.5 10 13 10 16.5V23.5C10 27 12 28.5 15 28.5H25C28 28.5 30 27 30 23.5V18.26C30 17.6 29.36 17.1 28.72 17.31ZM23.52 19.15L22.34 20.09C21.68 20.62 20.84 20.88 20 20.88C19.16 20.88 18.31 20.62 17.66 20.09L14.53 17.59C14.21 17.33 14.16 16.85 14.41 16.53C14.67 16.21 15.14 16.15 15.46 16.41L18.59 18.91C19.35 19.52 20.64 19.52 21.4 18.91L22.58 17.97C22.9 17.71 23.38 17.76 23.63 18.09C23.89 18.41 23.84 18.89 23.52 19.15Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_228_1495",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_228_1495",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 34.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_1495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.e815afad80987d7974804b10830ca164.svg";
export { ForwardRef as ReactComponent };